import { useSelector } from "react-redux";
import { State } from "@App/state";
import { getConfig } from "@App/utils/getConfig";
import { useEffect } from "react";
import i18n from "@App/utils/i18n";

export const useOrganizationConfig = () => {
  const organization = useSelector((state: State) => state.orders.organization);
  const config = getConfig(organization);

  // Change Language & Preset Filter
  useEffect(() => {
    i18n.changeLanguage(organization?.settings?.language);
  }, []);

  return {
    config,
  };
};
